'use client';

import dynamic from 'next/dynamic';
import { Button, Flex } from '@radix-ui/themes';
import ClientThemeProvider from '../../providers/client-theme-provider';
import { UserClient } from '@/app/lib/schemas/types/shared';
import SolidButton from '../shared/solid-button';

const ExpandableMenuAccountContainer = dynamic(
  () => import('./expandable-menu-account-container'),
  { ssr: false }
);

interface Props {
  user: UserClient | null;
  onSubscribe: () => void;
  onLogin: () => void;
}

const AccountControls = ({ user, onSubscribe, onLogin }: Props) => {
  if (user) {
    return (
      <ClientThemeProvider>
        <ExpandableMenuAccountContainer user={user} />
      </ClientThemeProvider>
    );
  }

  return (
    <Flex
      gap='4'
      align='center'
    >
      <Button
        variant='ghost'
        onClick={onSubscribe}
      >
        Оформить подписку
      </Button>
      <SolidButton onClick={onLogin}>Войти</SolidButton>
    </Flex>
  );
};

export default AccountControls;
